import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Row } from "../shared/Row";
import { flattenCssVariables } from "../utils/flattenCssVariables";
import { resolveCssVariable } from "../utils/resolveCssVariable";
import { CORE_COLORS } from "./constants";

export const Colors = () => {
  const { currentCanvasTheme, appearance } = useBuilderStore(state => ({
    currentCanvasTheme: state.currentCanvasTheme,
    appearance: state.appearance,
  }));

  const flattenedCssVariables = flattenCssVariables(
    currentCanvasTheme?.cssVariables,
    appearance,
  );

  return (
    <div className="flex flex-col gap-5 px-6 pt-5">
      {CORE_COLORS.map(({ name, title, variable }) => (
        <Row
          shouldRenderThemeColors={false}
          key={name}
          title={title}
          value={resolveCssVariable({
            value: flattenedCssVariables[variable],
            cssVariables: flattenedCssVariables,
          })}
          name={`theme.${appearance}.${name}`}
          cssVariables={flattenedCssVariables}
        />
      ))}
    </div>
  );
};
